export const AnswerType = Object.freeze({
  SINGLE_SELECTION: "SINGLE_SELECTION",
  MULTI_SELECTION: "MULTI_SELECTION",
  TEXT: "TEXT",
  COMBOBOX: "COMBOBOX",
  DATE: "DATE",
  TIME: "TIME",
  LINEAR_SCALE: "LINEAR_SCALE"
});
